import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const AuthCallback = () => {
  const history = useHistory();

  useEffect(() => {
    const loginRedirectPath = localStorage.getItem("loginRedirectPath");

    if (loginRedirectPath) {
      history.push(loginRedirectPath);
      localStorage.removeItem("loginRedirectPath");
    }
  }, [history]);

  return <div>Authenticated</div>;
};

export default AuthCallback;
